import { PermissaoService } from './permissao.service';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { BndesUx4 } from "@bndes/bndes-ux4/base";
import { BnFormValidationModule, BnFormErrorMessage } from "@bndes/bndes-ux4/bn-form-validation";


import { BlocoAnimadoComponent } from './bloco-animado/bloco-animado.component';
import { BN_MUST_NOT_MATCH } from 'src/app/constantes/validacao.constantes';
import { FuncionalidadeDesabilitadaComponent } from './funcionalidade-desabilitada/funcionalidade-desabilitada.component';
import { PipesModule } from '../pipes/pipes.module';
import { ProtocoloPesquisaComponent } from './protocolo-arquivos/protocolo-pesquisa.component';
import { ProtocoloEnvioComponent } from './protocolo-arquivos/protocolo-envio.component';
import { RouterModule } from '@angular/router';
import { ProtocoloListagemComponent } from './protocolo-arquivos/protocolo-listagem.component';
import { ModalConfirmDialogComponent } from './modal-confirm-dialog/modal-confirm-dialog.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { BnAlertsComponent } from '@bndes/bndes-ux4/bn-alerts';
import { BnLoadingOverlayComponent } from '@bndes/bndes-ux4/bn-loading-overlay';
import { BnHeaderComponent} from '@bndes/bndes-ux4/bn-header';
import { BnContainerComponent} from '@bndes/bndes-ux4/bn-container';
import { BnNavComponent } from '@bndes/bndes-ux4/bn-nav';
import { BnPaginacaoComponent } from '@bndes/bndes-ux4/bn-paginacao';
import { BnMaskPipe } from "@bndes/bndes-ux4/bn-mask/bn-mask-pipe";
import { BnMaskDirective } from "@bndes/bndes-ux4/bn-mask/bn-mask-directive";
import { BnDatepickerComponent } from '@bndes/bndes-ux4/bn-datepicker';
import { BnOrdenacaoComponent } from '@bndes/bndes-ux4/bn-ordenacao';
import { BnCnpjPipe } from '@bndes/bndes-ux4/pipes/cnpj';
import { BnFileUploaderComponent } from '@bndes/bndes-ux4/bn-file-uploader';
import { BnConfirmDirective } from '@bndes/bndes-ux4/bn-confirm';
import { NumbersOnlyDirective } from './directives/numbersonly';
import { NoSpacesDirective } from './directives/nospaces';
import {
  ProtocoloPesquisarIpdComponent
} from "./protocolo-ipd/protocolo-pesquisar-ipd/protocolo-pesquisar-ipd.component";
import {ProtocoloListarIpdComponent} from "./protocolo-ipd/protocolo-listar-ipd/protocolo-listar-ipd.component";


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BndesUx4.forRoot(
      { 'baseUrl': '.' ,
        'loginUrl': '/rest/public/a03/user/auth',
        'esqueciMinhaSenhaUrl': '/redefinir-senha',
        'cadastrarNovoUsuarioUrl': '/autocadastro',
        'chaveCaptchaLogin': '6Lc9Z3UUAAAAAOWKQzcBLU8vCl8c2gX2S0owP2dM',
        'exibirCnpjNoHeader': true,
      }),
    BnFormValidationModule.forRoot(BN_MUST_NOT_MATCH),
    PipesModule,

    BnAlertsComponent,
    BnLoadingOverlayComponent,
    BnHeaderComponent,
    BnContainerComponent,
    BnNavComponent,
    BnPaginacaoComponent,
    BnMaskPipe,
    BnCnpjPipe,
    BnMaskDirective,
    BnDatepickerComponent,
    BnOrdenacaoComponent,
    BnFileUploaderComponent,
    BnConfirmDirective,
    NgxCaptchaModule,
    NumbersOnlyDirective,
    NoSpacesDirective
  ],
  declarations: [
    BlocoAnimadoComponent,
    FuncionalidadeDesabilitadaComponent,
    ProtocoloEnvioComponent,
    ProtocoloPesquisaComponent,
    ProtocoloPesquisarIpdComponent,
    ProtocoloListagemComponent,
    ProtocoloListarIpdComponent,
    ModalConfirmDialogComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    BndesUx4,
    BnFormValidationModule,
    BlocoAnimadoComponent,
    PipesModule,
    ProtocoloEnvioComponent,
    ProtocoloPesquisaComponent,
    ProtocoloPesquisarIpdComponent,
    ProtocoloListarIpdComponent,
    ProtocoloListagemComponent,
    RouterModule,
    ModalConfirmDialogComponent,
    BnAlertsComponent,
    BnLoadingOverlayComponent,
    BnHeaderComponent,
    BnContainerComponent,
    BnNavComponent,
    BnPaginacaoComponent,
    BnDatepickerComponent,
    BnMaskPipe,
    BnCnpjPipe,
    BnMaskDirective,
    BnOrdenacaoComponent,
    BnFileUploaderComponent,
    BnConfirmDirective,
    NgxCaptchaModule,
    NumbersOnlyDirective,
    NoSpacesDirective
  ],
})
export class SharedModule {
}
